import { Link } from "react-router-dom";

export default function LinkButton(props) {
    const to = props.to;

  return (
    <Link to={to} className="align-center">
        <button 
          className="border-blue-950 border-4 rounded-sm bg-blue-800 p-2 mb-8 black-ops-font 
          hover:scale-105 text-white"
        >
          {props.children}
        </button>
    </Link>
  )
}
